// extracted by mini-css-extract-plugin
module.exports = {"main":"LoadingSpinner_main__9yFpy","spinner":"LoadingSpinner_spinner__Yf_tQ","spin":"LoadingSpinner_spin__WDy0E"};